import React from 'react';
import FadeIn from '../common/FadeIn';
import { IoIosCheckmark } from "react-icons/io";

const TemplateFeaturesMatrix = ({ template }) => {
  const siteFeatures = [
    {
      title: "Clean Design.",
      desc: "A professional look without the cost of a custom website."
    },
    {
      title: "Your Branding.",
      desc: "Your logo, colors, images, and content are added to the site."
    },
    {
      title: "Responsive.",
      desc: "Your website will look and work properly across desktop, tablet, and mobile."
    },
    {
      title: "Easy to Manage.",
      desc: "Works properly on desktop, tablet, and mobile."
    },
    {
      title: "Clear & Useful.",
      desc: "Easy pages and contact options help visitors find what they need."
    },
    {
      title: "Launch Support.",
      desc: "I help with the final setup, domain, HTTPS, and going live."
    }
  ];

  const defaultPagesIncluded = [
    "Home",
    "About",
    "Portfolio",
    "Services",
    "Contact",
    "404",
    "Maintanance Page"
  ];

  const defaultBonusPages = [
    "Facebook Link in Bio Page",
    "Instagram Links Page",
    "FAQ",
    "Terms & Conditions",
  ];

  const rawPages = [
    ...(template?.pagesIncluded || defaultPagesIncluded),
    ...(template?.bonusPages || defaultBonusPages)
  ];
  const pagesIncluded = Array.from(new Set(rawPages));

  return (
    <section className="w-full bg-[#f9f9f5] text-[#1C1917] py-16 sm:py-20 border-t border-[#E8E2D8]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 lg:gap-14 items-start">

          <div className="md:col-span-6 lg:col-span-5 flex flex-col">
            <FadeIn>
              <h3 className="font-PromenadeItalic text-base md:text-[18px] uppercase tracking-[0.25em] font-bold pb-3 mb-6 border-b border-[#D8CEBE]">
                SITE FEATURES
              </h3>
            </FadeIn>

            <ul className="space-y-5">
              {siteFeatures.map((item, idx) => (
                <FadeIn key={idx}>
                  <li className="flex items-start gap-2.5 text-xs sm:text-sm text-[#4A433A]">
                    <span className="font-serif italic font-semibold mt-0.5 select-none text-sm">
                      <IoIosCheckmark className="w-5 h-5 text-[#ce884d]" />
                    </span>
                    <p className="font-interDisplayMedium leading-relaxed font-light">
                      <strong className="font-medium text-[#1C1917]">{item.title}</strong> {item.desc}
                    </p>
                  </li>
                </FadeIn>
              ))}
            </ul>
          </div>

          {/* PAGES INCLUDED */}
          <div className="md:col-span-6 lg:col-span-7 flex flex-col">
            <FadeIn>
              <h3 className="font-PromenadeItalic text-base md:text-[18px] uppercase tracking-[0.25em] font-bold pb-3 mb-6 border-b border-[#D8CEBE] w-full">
                PAGES INCLUDED
              </h3>
            </FadeIn>

            <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 lg:gap-x-10 gap-y-2">
              {pagesIncluded.map((page, idx) => (
                <FadeIn key={idx}>
                  <li className="font-interDisplayMedium text-xs sm:text-sm text-[#38332E]">
                    {page}
                  </li>
                </FadeIn>
              ))}
            </ul>
          </div>

        </div>

      </div>
    </section>
  );
};

export default TemplateFeaturesMatrix;

